import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  SITE_URL,
  SITE_NAME,
  SITE_TAGLINE,
  SITE_DESCRIPTION,
  OG_IMAGE_PATH,
  TWITTER_IMAGE_PATH,
  absoluteUrl,
} from '../config/site';
import { buildGraph } from '../seo/schema';
import { faqs } from './FAQ';
import { steps as howToSteps } from './HowToUse';

const TITLE = `${SITE_NAME} Converter - ${SITE_TAGLINE} | Free Online Tool`;

const SEOMetadata: React.FC = () => {
  const graph = buildGraph({ faqs, howToSteps });

  return (
    <Helmet>
      <title>{TITLE}</title>
      <meta name="title" content={TITLE} />
      <meta name="description" content={SITE_DESCRIPTION} />
      <meta
        name="keywords"
        content="JSON to TOON, TOON converter, reduce tokens, LLM optimization, GPT-4 cost savings, Claude optimization, token compression, JSON optimization, AI cost reduction"
      />
      <meta name="author" content={SITE_NAME} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <link rel="canonical" href={SITE_URL} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={SITE_URL} />
      <meta property="og:title" content={TITLE} />
      <meta property="og:description" content={SITE_DESCRIPTION} />
      <meta property="og:image" content={absoluteUrl(OG_IMAGE_PATH)} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={SITE_URL} />
      <meta name="twitter:title" content={TITLE} />
      <meta name="twitter:description" content={SITE_DESCRIPTION} />
      <meta name="twitter:image" content={absoluteUrl(TWITTER_IMAGE_PATH)} />

      <script type="application/ld+json">{JSON.stringify(graph)}</script>
    </Helmet>
  );
};

export default SEOMetadata;
